import { isNullish } from 'remeda';

import { Nullable } from 'v2/types';

export const localStorageService = {
  get<Value>(key: string): Nullable<Value> {
    const value = localStorage.getItem(key);

    if (isNullish(value)) {
      return null;
    }

    return JSON.parse(value);
  },

  set<Value>(key: string, value: Value): void {
    localStorage.setItem(key, JSON.stringify(value));
  },
};
